<script>
import {
    speakerState
} from '@app/store/speakerStore.svelte.js';
import {
    resetHistory, insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import {
    issueState
} from '@app/store/issueStore.svelte.js';
import {
    markerState
} from '@app/store/markerStore.svelte.js';
import {
    metadataState
} from '@app/store/metadataStore.svelte.js';
import {
    styleState
} from '@app/store/styleStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    environment
} from '@app/store/envStore.svelte.js';
import { toast } from '@zerodevx/svelte-toast';
import {
    saveAs
} from 'file-saver';

import { ccprjFunc } from '@app/lib/ccprj.js';
import Swal from 'sweetalert2'
import { SWAL_BASE, SWAL_CLASSES } from "@app/lib/swalClasses.js";
import * as m from '@app/paraglide/messages.js';

async function saveProject() {
    try {
        if (environment.electron) {
            const ipcRenderer = window.ipcRenderer;
            const fs = window.fs;
            if (projectState.localPath) {
                let projectJson = ccprjFunc.createCcprj({
                    project : JSON.parse(JSON.stringify(projectState)),
                    metadata : JSON.parse(JSON.stringify(metadataState)),
                    speakers : JSON.parse(JSON.stringify(speakerState)),
                    issues : JSON.parse(JSON.stringify(issueState.value)),
                    markers : JSON.parse(JSON.stringify(markerState)),
                    eventGroups : JSON.parse(JSON.stringify(eventGroupState)),
                    style : JSON.parse(JSON.stringify(styleState))
                });

                await fs.writeFile(projectState.localPath, JSON.stringify(projectJson, null, 4));

                toast.push(m.save_completed_success(), {classes: ['toast-success']});

            } else {
                let filePath = await ipcRenderer.invoke('openSaveDialog', {
                    title: m.save_project(),
                    defaultPath: `${projectState.name}.ccprj`,
                    properties: ["showOverwriteConfirmation", "createDirectory"]
                });

                console.log(filePath);
                if (filePath.canceled) {
                    throw new Error("Save process cancelled by user");
                }

                projectState.localPath = filePath.filePath;
                projectState.name = filePath.filePath.replace(/^.*[\\\/]/, '').replace(/\.ccprj/g, "");

                let projectJson = ccprjFunc.createCcprj({
                    project : JSON.parse(JSON.stringify(projectState)),
                    metadata : JSON.parse(JSON.stringify(metadataState)),
                    speakers : JSON.parse(JSON.stringify(speakerState)),
                    issues : JSON.parse(JSON.stringify(issueState.value)),
                    markers : JSON.parse(JSON.stringify(markerState)),
                    eventGroups : JSON.parse(JSON.stringify(eventGroupState)),
                    style : JSON.parse(JSON.stringify(styleState))
                });
                await fs.writeFile(projectState.localPath, JSON.stringify(projectJson, null, 4));

                toast.push(m.save_completed_success(), {classes: ['toast-success']});
            }

            resetHistory();
            insertHistoryAction({
                name: "save project", //action name
                eventGroup: projectState.selected,
                snapshots: [
                    {
                        store: "eventGroupState",
                        value: JSON.stringify(eventGroupState)
                    }                
                ]
            });
        } else {
            let projectJson = ccprjFunc.createCcprj({
                project : JSON.parse(JSON.stringify(projectState)),
                metadata : JSON.parse(JSON.stringify(metadataState)),
                speakers : JSON.parse(JSON.stringify(speakerState)),
                issues : JSON.parse(JSON.stringify(issueState.value)),
                markers : JSON.parse(JSON.stringify(markerState)),
                eventGroups : JSON.parse(JSON.stringify(eventGroupState)),
                style : JSON.parse(JSON.stringify(styleState))
            });
            
            let fileBlob = new Blob([JSON.stringify(projectJson, null, 4)], {
                type: "text/plain;charset=utf-8"
            });

            saveAs(fileBlob, projectState.name + ".ccprj", {
                autoBom: true
            });

            resetHistory();
            insertHistoryAction({
                    name: "save project", //action name
                    eventGroup: projectState.selected,
                    snapshots: [
                        {
                            store: "eventGroupState",
                            value: JSON.stringify(eventGroupState),
                        }
                    ],
                });
        }
    } catch (err) {
        console.log(err, err.message);
        toast.push(m.save_completed_error({ error: err.message }), {classes: ['toast-danger']});
    }
}

async function saveProjectAs() {
    try {
        if (environment.electron) {
            let filePath = await ipcRenderer.invoke('openSaveDialog', {
                title: m.save_project(),
                defaultPath: `${projectState.name}.ccprj`,
                properties: ["showOverwriteConfirmation", "createDirectory"]
            });

            if (filePath.canceled) {
                throw new Error("Save process cancelled by user");
            }

            projectState.localPath = filePath.filePath;
            projectState.name = filePath.filePath.replace(/^.*[\\\/]/, '').replace(/\.ccprj/g, "");

            let projectJson = ccprjFunc.createCcprj({
                project : JSON.parse(JSON.stringify(projectState)),
                metadata : JSON.parse(JSON.stringify(metadataState)),
                speakers : JSON.parse(JSON.stringify(speakerState)),
                issues : JSON.parse(JSON.stringify(issueState.value)),
                markers : JSON.parse(JSON.stringify(markerState)),
                eventGroups : JSON.parse(JSON.stringify(eventGroupState)),
                style : JSON.parse(JSON.stringify(styleState))
            });

            await fs.writeFile(projectState.localPath, JSON.stringify(projectJson, null, 4));

            toast.push(m.save_completed_success(), {classes: ['toast-success']});
            
            resetHistory();
            insertHistoryAction({
                name: "save project", //action name
                eventGroup: projectState.selected,
                snapshots: [
                    {
                        store: "eventGroupState",
                        value: JSON.stringify(eventGroupState),
                    }
                ],
            });
        } else {
            let projectJson = ccprjFunc.createCcprj({
                project : JSON.parse(JSON.stringify(projectState)),
                metadata : JSON.parse(JSON.stringify(metadataState)),
                speakers : JSON.parse(JSON.stringify(speakerState)),
                issues : JSON.parse(JSON.stringify(issueState.value)),
                markers : JSON.parse(JSON.stringify(markerState)),
                eventGroups : JSON.parse(JSON.stringify(eventGroupState)),
                style : JSON.parse(JSON.stringify(styleState))
            });
            let fileBlob = new Blob([JSON.stringify(projectJson, null, 4)], {
                type: "text/plain;charset=utf-8"
            });

            Swal.fire({
                ...SWAL_BASE,
                customClass: SWAL_CLASSES.denyCancel,
                titleText: m.project_name(),
                text: m.enter_project_name(),
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: m.save(),
                denyButtonText: m.cancel(),
                allowOutsideClick: false,
                allowEscapeKey: false,
                inputLabel: m.project_name(),
                inputPlaceholder: projectState.name,
                input: "text",
            }).then((result) => {
                //console.log(result);
                if (result.isConfirmed) {
                    let projectName = result.value;
                    if (projectNamed) {
                        projectState.name = projectName;
                    }
                }

                saveAs(fileBlob, projectState.name + ".ccprj", {
                    autoBom: true
                });

                resetHistory();
                insertHistoryAction({
                    name: "save project", //action name
                    eventGroup: projectState.selected,
                    snapshots: [
                        {
                            store: "eventGroupState",
                            value: JSON.stringify(eventGroupState),
                        }
                    ],
                });
            });
        }
    } catch (err) {
        console.log(err, err.message);
        toast.push(m.save_completed_error({ error: err.message }), {classes: ['toast-danger']});
    }
}
</script>

<a class="dropdown-item" 
   href="#!/" 
   id="offlineSaveMenuItem"
   role="menuitem"
   aria-label={m.save_project_desc()}
   onclick={() => projectState.localPath ? saveProject() : saveProjectAs()}>{m.save_project()}</a>
<a class="dropdown-item" 
   href="#!/" 
   id="offlineSaveAsMenuItem"
   role="menuitem"
   aria-label={m.save_project_as_desc()}
   onclick={saveProjectAs}>{m.save_project_as()}</a>
